/*
 * @Author: Yun
 * @Date: 2024-02-17 14:36:43
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-01 06:53:41
 */

import React, { useState } from 'react'
import retry from '@images/footer/retry.png'
import share from '@images/footer/share.png'
import txt from '@images/footer/txt.png'
import shareImg from '@images/footer/share-img.png'
import $ from 'jquery'
import './index.less'

const PREFIX = 'footer'

const Footer = (props) => {
    const [active, setActive] = useState(false)

    const onRetry = () => {
        $('body').scrollTo({ left: 0, top: 0 }, 0.1)
    }

    const onShare = () => {
        $('body').css('overflow', 'hidden')
        setActive(true)
    }

    const onClose = () => {
        $('body').css('overflow', 'auto')
        setActive(false)
    }

    return (
        <section className={PREFIX}>
            <div className={`${PREFIX}-wrapper`}>
                {/*<div className={`${PREFIX}-txt`}>
                    <div className={`${PREFIX}-txt-txt1`}>
                        In 2023, NPC deputies submitted 271 bills, all of which were thoroughly
                        reviewed. In 2022, government agencies handled 8,721 proposals from NPC
                        deputies and 5,865 proposals from CPPCC members, accounting for 94.8% and
                        95% of the total respectively. More than 4,100 proposals were adopted, with
                        2,100 of them turned into policies or measures. In the past five years, more
                        than 18,000 proposals have been adopted, and more than 7,800 relevant
                        policies and measures have been introduced.
                    </div>
                    <div className={`${PREFIX}-txt-txt2`}>
                        2023年，人大代表提出议案271件，均已审议完毕。2022年国务院部门共办理人大代表建议8721件，政协委员提案5865件，分别占建议、提案总数的94.8%和95%。共采纳意见建议4100余条，出台相关政策措施近2100项。过去五年，累计采纳意见建议1.8万余条，出台相关政策措施7800余项。
                    </div> 
                    
                </div>*/}
                <img className={`${PREFIX}-txtImg`} src={txt} alt="" />
                {/* <div className={`${PREFIX}-cover`}>这里还有内容哦</div> */}
                <div className={`${PREFIX}-buttons`}>
                    <img
                        className={`${PREFIX}-buttons-button ${PREFIX}-buttons-retry`}
                        src={retry}
                        alt=""
                        onClick={onRetry}
                    />
                    <img
                        className={`${PREFIX}-buttons-button ${PREFIX}-buttons-share`}
                        src={share}
                        alt=""
                        onClick={onShare}
                    />
                </div>
            </div>
            {active && (
                <div className={`${PREFIX}-shareBlock`}>
                    <img className={`${PREFIX}-shareImg`} onClick={onClose} src={shareImg} alt="" />
                </div>
            )}
        </section>
    )
}

export default Footer
